import { Link } from 'react-router-dom';
import { FOOTER_EXPLORE_LINKS, FOOTER_COMPANY_LINKS } from '../../../data/navigation';
import { COMPANY, CONTACT } from '../../../constants';
import './Footer.css';

const IconInstagram = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const IconTwitterX = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const IconLinkedIn = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const IconFacebook = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.268h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);

function FooterNavLink({ href, router, children }) {
  if (router) {
    return (
      <Link to={href} className="footer-col__link">
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className="footer-col__link">
      {children}
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">

        {/* ── Brand Column ── */}
        <div className="footer-brand">
          <a href="/" className="footer-brand__logo-link">
            <img
              src="/NimbleShortLet.png"
              alt="NimbleShortLet Logo"
              className="footer-brand__logo"
            />
          </a>

          <p className="footer-brand__desc">{COMPANY.description}</p>

          <div className="footer-brand__badge">
            <span className="footer-brand__badge-dot" aria-hidden="true" />
            {COMPANY.positioning}
          </div>

          <div className="footer-brand__social">
            <a
              href="https://www.instagram.com/nimblecasa/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-btn"
              aria-label="Follow us on Instagram"
            >
              <IconInstagram />
            </a>
            <a
              href="https://x.com/NimbleCasa"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-btn"
              aria-label="Follow us on X"
            >
              <IconTwitterX />
            </a>
            <a
              href="https://www.linkedin.com/company/nimblecasa/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-btn"
              aria-label="Follow us on LinkedIn"
            >
              <IconLinkedIn />
            </a>
            <a
              href="https://www.facebook.com/people/NimbleCasa/61554805858914/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-btn"
              aria-label="Follow us on Facebook"
            >
              <IconFacebook />
            </a>
          </div>
        </div>

        {/* ── Explore Column ── */}
        <div className="footer-col">
          <h3 className="footer-col__heading">Explore</h3>
          <ul className="footer-col__list">
            {FOOTER_EXPLORE_LINKS.map((link) => (
              <li key={link.label}>
                <FooterNavLink href={link.href} router={link.router}>
                  {link.label}
                </FooterNavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Company Column ── */}
        <div className="footer-col">
          <h3 className="footer-col__heading">Company</h3>
          <ul className="footer-col__list">
            {FOOTER_COMPANY_LINKS.map((link) => (
              <li key={link.label}>
                <FooterNavLink href={link.href} router={link.router}>
                  {link.label}
                </FooterNavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Contact Column ── */}
        <div className="footer-col">
          <h3 className="footer-col__heading">Get in Touch</h3>
          <div className="footer-contact-list">
            <div className="footer-contact-item">
              <span className="footer-contact-item__label">Phone</span>
              <a href={CONTACT.phoneHref} className="footer-contact-item__value footer-contact-item__tel">
                {CONTACT.phone}
              </a>
            </div>
            <a href={CONTACT.emailHref} className="footer-contact-item footer-contact-item--link">
              <span className="footer-contact-item__label">Email</span>
              <span className="footer-contact-item__value">{CONTACT.email}</span>
            </a>
            <div className="footer-contact-item">
              <span className="footer-contact-item__label">Visit Us</span>
              <span className="footer-contact-item__value">{CONTACT.addressShort}</span>
            </div>
            <a
              href={CONTACT.websiteHref}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-item footer-contact-item--link"
            >
              <span className="footer-contact-item__label">Website</span>
              <span className="footer-contact-item__value">{CONTACT.website}</span>
            </a>
          </div>
        </div>

      </div>

      {/* ── Bottom Bar ── */}
      <div className="site-footer__bottom">
        <p className="site-footer__copy">
          © {COMPANY.year} {COMPANY.name}. All rights reserved.
        </p>
        <p className="site-footer__tagline">
          Engineered by{' '}
          <a
            href="https://nimble-byte.com"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__credit-link"
          >
            Nimble-Byte
          </a>
        </p>
      </div>
    </footer>
  );
}
